import http from '../http/http';
import URL from '../constant/URL';

const { GM } = URL.API;

// GM 이메일 로그인
export const gmEmailLoginAPI = async (data) => {
  let result = null;
  await http.request({
    url: `${GM.EMAIL_LOGIN}`,
    method: http.METHOD.POST,
    data,
    success: (resp, code) => {
      result = {
        resp, code 
      }
    },
    error: (error) => {
      if (error?.code) {
        result = {
          data: error.data,
          code: error.code
        }
      }
     },
  });

  return result;
};

// 학습자 선택
export const learnerChoiceAPI = async (data) => {
  let result = null;
  const { sbsceMbrId, cstmrNo, contract } = data;
  
  await http.request({
    url: `${GM.I}/member/${sbsceMbrId}/customer/${cstmrNo}/contract/${contract}`,
    success: (resp) => { result = resp; },
    error: (error) => { result = error; },
  });

  return result;
}

// GM 탈패드 이메일 인증 발송
export const emailSendAPI = async (data) => {
  let result = null;
  await http.request({
    url: `${GM.EMAIL_SEND}`,
    method: http.METHOD.POST,
    data: { ...data, langCd: 'KO' },
    success: (resp, code) => {
      result = {
        resp, code
      };
     },
    error: (error) => { throw error; }
  });

  return result;
}

// GM 이메일 변경
export const emailChangeAPI = async (data) => {
  let result = null;
  const { sbsceMbrId } = data;
  await http.request({
    url: `${GM.MEMBERS}/${sbsceMbrId}`,
    method: http.METHOD.PUT,
    data,
    success: (resp, code) => {
      result = {
        resp, code
      }
    },
    error: (error) => { throw error },
  });

  return result;
}

// GM 비밀번호 변경
export const pwdChangeAPI = async (data) => {
  let result = null;
  const { sbsceMbrId } = data;
  await http.request({
    url: `${GM.MEMBERS}/${sbsceMbrId}`,
    method: http.METHOD.PUT,
    data,
    success: (resp, code) => {
      result = { resp, code }
    },
    error: (error) => { throw error }
  });

  return result;
}

// GM 앱 계정 신청
export const appIdSignAPI = async (data) => {
  let result = null;
  const { sbsceMbrId } = data;

  await http.request({
    url: `${GM.MEMBERS}/${sbsceMbrId}`,
    method: http.METHOD.PUT,
    data,
    success: (resp, code) => {
      result = {resp, code};
    },
    error: (error) => {
      if (error?.code) {
        result = {
          data: error.data,
          code: error.code
        }
      } else {
        throw error;
      }
    }
  });

  return result;
}

// 이메일 인증번호 확인
export const emailVerifyAPI = async (data) => {
  let result = null;
  await http.request({
    url: `${GM.EMAIL_VERIFY}`,
    method: http.METHOD.POST,
    data,
    success: (resp, code) => {
      result = {
        resp, code
      }
    },
    error: (error, code) => {
      if (error?.code) {
        result = { resp: error, code: error.code }
      } else {
        throw error;
      }
    }
  });

  return result;
};

// 임시 비밀번호 발송
export const pwInquiryAPI = async (data) => {
  let result = "";
  await http.request({
    url: `${GM.PW_INQUIRY}`,
    method: http.METHOD.POST,
    data: { ...data, langCd: 'KO' },
    success: (resp, code) => {
      result = { resp, code }
    },
    error: (error) => {
      result = { error, code: error?.code }
    }
  });

  return result;
};

// 교문 회원조회
export const memberSelAPI = async (data) => {
  let result = null;
  await http.request({
    url: `${GM.I}/member`,
    method: http.METHOD.POST,
    data,
    success: (resp, code) => {
      result = { resp, code }
    },
    error: (error) => {
      if (error?.code) result = {
        code: error.code,
        resp: error
      }
      throw error;
    }
  });

  return result;
}

// 교문 회원 가입
export const memberJoinAPI = async (data) => {
  let result = null;
  await http.request({
    url: `${GM.I}/member`,
    method: http.METHOD.PUT,
    data,
    success: (resp, code) => {
      result = { resp, code }
    },
    error: (error) => {
      if (error?.code) {
        result = { code: error.code, resp: error }
      }
      else throw error;
    }
  });

  return result;
}

// 교문 APP 계정 신청 정보
export const membersInfo = async (mbrId) => {
  let result = null;
  await http.request({
    url: `${GM.MEMBERS}/${mbrId}`,
    success: (resp, code) => {
      result = { resp, code }
    },
    error: (error) => {
      if (error?.code) {
        result = { code: error.code, resp: error }
      }
      else throw error;
    }
  });

  return result;
}

export const appAutoLoginRegAPI = async (data) => {
  let result = null;
  await http.request({
    url: `${GM.AUTO_LOGIN_REG}`,
    method: http.METHOD.PUT,
    data,
    success: (resp, code) => {
      result = { resp, code }
    },
    error: (error) => {
      if (error?.code) {
        result = { code: error.code, resp: error }
      }
      else throw error;
    }
  });

  return result;
}

export const appAutoLoginAPI = async (data) => {
  let result = null;
  await http.request({
    url: `${GM.AUTO_LOGIN}`,
    method: http.METHOD.POST,
    data,
    success: (resp, code) => {
      result = { resp, code }
    },
    error: (error) => {
      if (error?.code) {
        result = { code: error.code, resp: error }
      }
      else throw error;
    }
  });

  return result;
}

// 글로벌 로그인
export const globalLoginAPI = async (data) => {
  let result = null;
  await http.request({
    url: `${URL.API.GLOBAL.LOGIN}`,
    method: http.METHOD.POST,
    data,
    success: (resp, code) => {
      result = { resp, code }
    },
    error: (error) => {
      if (error?.code) result = { code: error.code, resp: error};
      else throw error;
    }
  })

  return result;
}

// 글로벌 자동 로그인 등록
export const globalAutoLogin = async (data) => {
  let result = null;
  await http.request({
    url: `${URL.API.GLOBAL.AUTO_LOGIN}`,
    method: http.METHOD.POST,
    data,
    success: (resp, code) => {
      result = { resp, code }
    },
    error: (error) => {
      if (error?.code) result = { code: error.code, resp: error };
      else throw error;
    }
  })

  return result;
}

// 글로벌 회원 가입
export const globalSignupAPI = async (data) => {
  let result = null;

  await http.request({
    url: `${URL.API.GLOBAL.SIGNUP}`,
    method: http.METHOD.POST,
    data,
    success: (resp, code) => {
      result = { resp, code }
    },
    error: (error) => {
      if (error?.code) result = { code: error.code, resp: error };
      else throw error;
    }
  });
  return result;
}

// 학습 회원 정보 변경
export const useNameChangeAPI = async (data) => {
  let result = null;
  const { member, learner } = data;
  await http.request({
    url: `${URL.API.MEMBERS.MEMBERS}/${member}/learners/${learner}`,
    method: http.METHOD.PUT,
    data,
    success: (resp, code) => {
      result = { resp, code }
    },
    error: (error) => {
      if (error?.code) result = { code: error.code, resp: error };
      else throw error;
    }
  });

  return result;
}

// 마케딩 동의여부 수정
export const userMarketingModAPI = async (data) => {
  let result = null;
  const { member } = data;
  await http.request({
    url: `${URL.API.MEMBERS.MEMBERS}/${member}/terms`,
    method: http.METHOD.PUT,
    data,
    success: (resp, code) => {
      result = { resp, code }
    },
    error: (error) => {
      if (error?.code) result = { code: error.code, resp: error };
      else throw error;
    }
  });

  return result;
}

// 회원탈퇴
export const userLeaveAPI = async (data) => {
  let result = null;
  // const { mbrId } = data;
  await http.request({
    url: `${URL.API.MEMBERS.MEMBERS}/revoke`,
    method: http.METHOD.DELETE,
    data,
    success: (resp, code) => {
      result = { resp, code }
    },
    error: (error) => {
      if (error?.code) result = { code: error.code, resp: error };
      else throw error;
    }
  });

  return result;
}